import { Body1, Divider, Link, Subtitle1, makeStyles, tokens } from '@fluentui/react-components'
import { DismissCircle48Color } from '@fluentui/react-icons'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { DOCS_SUPPORT_URL } from '../../constants/urls'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    boxSizing: 'border-box',
    padding: tokens.spacingHorizontalXXL,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXL,
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: '1 0 0',
    width: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXL,
    alignItems: 'flex-start',
  },
  title: {
    margin: 0,
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXL,
  },
})

interface ErrorPageLayoutProps {
  title: string
  body: string
  children?: ReactNode
  icon?: ReactNode
}

export const ErrorPageLayout = ({ title, body, children, icon }: ErrorPageLayoutProps) => {
  const { t } = useTranslation()
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.header}>
          {icon ?? <DismissCircle48Color aria-hidden="true" />}
          <Subtitle1 as="h1" className={styles.title}>
            {title}
          </Subtitle1>
        </div>
        <Body1 as="p">{body}</Body1>
        {children}
      </div>
      <div className={styles.footer}>
        <Divider />
        <Link as="a" href={DOCS_SUPPORT_URL} target="_blank" rel="noopener noreferrer">
          {t('errorBoundary.contactSupport')}
        </Link>
      </div>
    </div>
  )
}
